<template>
  <transition name="fade">
    <div v-if="showed" id="confirm" class="popup__wrapper popup__add-user popup__add d-flex" @mousedown="close($event)">
      <div class="popup">
        <div class="popup__title">
          <div class="title">Confirm</div>
        </div>
        <div class="form__bent">
          <label class="form__label">{{ message }}</label>
        </div>
        <div class="popup__cellar">
          <button class="popup__submit" @click="confirmed">Ok</button>
          <button class="popup__cancel float-right" @click="close(true)">Cancel</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import { events } from './events'

  export default {
    name: 'confirm',
    data() {
      return {
        showed: false,
        message: null,
        callback: null,
      }
    },
    methods: {
      show(data) {
        this.showed = true
        this.message = data.message
        this.callback = data.callback
      },
      close(event) {
        if (event === true || event.target.id === 'confirm')
          this.clear()
      },
      confirmed() {
        if (this.callback)
          this.callback(true)
        this.clear()
      },
      clear() {
        this.showed = false
        this.message = ''
        this.callback = false
      }
    },
    mounted() {
      if (!document) return
      events.$on('show', this.show)
      events.$on('close', () => {
        this.close(true)
      })
    },
  }
</script>

<style scoped>
  .popup__wrapper {
    background-color: #F0F1F4cc;
    z-index: 999;
  }
</style>